import { useSelector } from 'react-redux';
import { BET_BUILDER_LANGUAGE_MAPPING } from 'utils/constants/languages/language-format';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { getOddFormat } from 'store/selectors/betslip';

export const priceTypes = {
  0: 'DecimalPrice',
  1: 'FractionalPrice',
  2: 'AmericanPrice',
  3: 'HongKongPrice',
  4: 'MalayPrice',
  5: 'IndoPrice'
};

export type TPriceTypesKeys = keyof typeof priceTypes;

export const useGenerateBetBuilderUrl = ({
  fixtureId
}: {
  fixtureId: number;
}) => {
  const oddFormat = useSelector(getOddFormat) as unknown as TPriceTypesKeys;

  const language = document.documentElement.lang.slice(
    0,
    2
  ) as keyof typeof BET_BUILDER_LANGUAGE_MAPPING;

  const generateBetBuilderUrl = () => {
    if (!SpringConfigs.BET_BUILDER_URL) {
      return '';
    }

    const odds = priceTypes[oddFormat] || priceTypes['0'];
    const culture =
      BET_BUILDER_LANGUAGE_MAPPING[document.documentElement.lang] ||
      BET_BUILDER_LANGUAGE_MAPPING[language] ||
      'en-GB';

    return `${
      SpringConfigs.BET_BUILDER_URL
    }${fixtureId}&culture=${culture}&odds=${odds}${
      SpringConfigs.BET_BUILDER_URL.includes('brand=') ? '' : '&brand=default'
    }`;
  };

  return generateBetBuilderUrl();
};
